import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_PARTNER_GET_STRIPE_ACCOUNT } from 'api/actionTypes';

export default async function loadPartnerStripeAccountBySlug({ state, apiClient }, { slug }) {
  typeCheck('slug::NonEmptyString', slug);
  const statePath = ['partnerStripeAccountsBySlug', slug];
  if (state.exists(statePath)) {
    return state.get(statePath);
  }
  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_STRIPE_ACCOUNT,
    queryId: slug,
    state: state,
    payload: {
      slug,
    },
    onSuccess(stripeAccount) {
      state.set(statePath, stripeAccount);
    },
  });
}
